import { debounce } from './utilities/debounce';

const header = document.querySelector('header');
let currentUserYPos = window.scrollY;
let headerHeight = header.offsetHeight;

const showOrHideHeader = debounce(() => {
    const newUserYPos = window.scrollY;
    const scrollingDown = currentUserYPos < newUserYPos;
    const isFixed = header.classList.contains('nav-container--fixed');
    const headerVisible = header.getAttribute('data-visible') !== 'false';

    // scrolling logic
    if (scrollingDown && headerVisible && newUserYPos > headerHeight) {
        headerSlideUp();
    } else if (!scrollingDown) {
        if (isFixed && newUserYPos === 0) {
            header.classList.remove('nav-container--fixed');
        }
        if (!headerVisible) {
            headerSlideDown();
        }
    }

    // Record the user's new scroll position no matter what.
    setTimeout(() => {
        currentUserYPos = window.scrollY;
    }, 50);
}, 60);

const headerSlideUp = () => {
    const isFixed = header.classList.contains('nav-container--fixed');
    header.setAttribute('style', `transform: translateY(-${headerHeight}px)`);
    // setTimeout is needed to account for scrolling animation
    setTimeout(() => {
        header.classList.remove('header--scrolled-down');
        header.setAttribute('data-visible', 'false');
        if (!isFixed) {
            header.classList.add('nav-container--fixed');
        }
    }, 300);
};

const headerSlideDown = () => {
    header.setAttribute('style', `transform: translateY(0)`);
    header.setAttribute('data-visible', 'true');
    header.classList.add('header--scrolled-down');
};

addEventListener('scroll', showOrHideHeader);
